import { ISharedConfig, setSession, setSnackbar } from '@shared/library';
import axios, { AxiosError } from 'axios';
import React from 'react';
import packageJson from '../../package.json';
import config from '../config';

const POLLING_INTERVAL = 60_000;//1 minute

const checkPollingStatus = (endpoint: "Auth/SessionValid" | `Gest/Software/WebGest/frontend/${string}/${string}/IsChanged`) =>
    axios.get<{ token: string; } | boolean>(`${config.api.internal}/${endpoint}`, { withCredentials: true })
        .then(res => res.data)
        .catch((error: AxiosError) => endpoint === "Auth/SessionValid" ? error?.status !== 401 : false);

/** While there is a logged user, every minute: is the session still valid (when not, back to the login) and is the version of the app still the released one (when not, reload) */
export const useSessionPolling = (cntxConfig: ISharedConfig) => {
    const isPolling = React.useRef(false);

    React.useEffect(() => {
        if (!cntxConfig.session?.userData) {
            return;
        }

        const interval = setInterval(async () => {
            if (!isPolling.current) {
                isPolling.current = true;

                const isLoggedIn = await checkPollingStatus("Auth/SessionValid");

                if (!isLoggedIn) {
                    setSnackbar(cntxConfig, { message: "Sessione scaduta. Ritorno alla login in corso...", severity: "error" });
                    setTimeout(() => setSession(cntxConfig), 3_000);
                }
                else if (await checkPollingStatus(`Gest/Software/WebGest/frontend/${process.env.REACT_APP_ENV ?? "sviluppo"}/${packageJson.version}/IsChanged`)) {
                    setSnackbar(cntxConfig, { message: "Aggiornamento della versione. E' necessario ricaricare la pagina", severity: "info" });
                    setTimeout(() => window.location.reload(), 3_000);
                }

                isPolling.current = false;
            }
        }, POLLING_INTERVAL);

        return () => clearInterval(interval);
    }, [cntxConfig.session?.userData]);
};
